<template>
  <div>
    <Header>
      Edycja usług
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Czas trwania usługi (minuty):">
            <b-input v-model="form.duration" type="number"/>
          </b-form-group>

          <b-row>
            <b-col
              v-for="service in services" :key="service.id"
              xl="6"
            >
              <h5 v-html="service.name_html"/>
              <b-form-group label="Nazwa:">
                <b-textarea v-model="service.name_html" rows="3"/>
              </b-form-group>
              <b-form-group label="Koszt (zł):">
                <b-input v-model="service.price" type="number"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('settings.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="check"/>
                  Zapisz
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'
import _ from "lodash";

export default {
  components: {
    Header,
    Errors,
  },
  layout: Layout,
  props: {
    duration: Number,
    services: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        duration: this.duration,
        services: this.services,
      }),
    }
  },
  methods: {
    submit() {
      this.form.put(this.route('services.update'))
    },
  },
}
</script>
